import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AbsenceSalarieDto } from "../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import $ from "jquery";

@Component
export default class ModalDetailAbsence extends Vue {
	public absence?: AbsenceSalarieDto = undefined;

	public init(absence: AbsenceSalarieDto): void {
    	this.absence = absence;
    	this.$forceUpdate();
	}

	public save(): void {
    	$("#modalDetailAbsence").modal("hide");
    	this.$forceUpdate();
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/modals/modalDetailAbsence/modalDetailAbsence.ts